import { ClauseWording } from '../types/policy';

export const parseLandlordName = (clauseWording: ClauseWording | undefined) => {
  if (!clauseWording?.clauseWordingLines) return undefined;
  const index = clauseWording.clauseWordingLines.findIndex(
    (line) => line.wording === 'Name of landlord                        Situation(s)'
  );
  if (index === undefined || index === -1 || clauseWording.clauseWordingLines.length < index + 2) {
    return undefined;
  }

  return clauseWording.clauseWordingLines[index + 1].wording?.substring(0, 34).trimEnd();
};
